<script setup lang="ts">
  import type { Editor } from '@tiptap/vue-3';

  import { Button } from '@ui/components/button';
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
  } from '@ui/components/dropdown-menu';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';

  const props = defineProps<{
    editor: Editor;
    toggleClass?: string;
  }>();

  const fontFamilyOptions = [
    {
      label: 'Sans Serif',
      value: 'Manrope, sans-serif',
      style: 'font-family: Manrope, sans-serif',
    },
    { label: 'Serif', value: 'serif', style: 'font-family: serif' },
    { label: 'Monospace', value: 'monospace', style: 'font-family: monospace' },
  ];

  const handleFontFamilyChange = (value: string) => {
    props.editor.chain().focus().setFontFamily(value).run();
  };
</script>

<template>
  <Tooltip>
    <TooltipTrigger as-child>
      <DropdownMenu>
        <DropdownMenuTrigger as-child>
          <Button :class="toggleClass" size="icon-sm" type="button" variant="ghost">
            <i class="fa fa-font" aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="top">
          <DropdownMenuItem
            v-for="option in fontFamilyOptions"
            :key="option.value"
            :style="option.style"
            @click="handleFontFamilyChange(option.value)"
          >
            {{ option.label }}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </TooltipTrigger>
    <TooltipContent side="bottom"> Font Family </TooltipContent>
  </Tooltip>
</template>
